import React from 'react';
import { withRouter } from 'react-router-dom';
import { Image } from 'components/atoms/image';
import { RouteUtil } from 'utils/RouteUtil';
import './styles.scss';

const JoinOurTeamMobileCard = props => {
  const {
    name,
    listMobileImageUrl,
    thumbNailUrlMobile,
    distance,
    city,
    country,
    length,
  } = props.data;

  const location = `${city},${' '}${country}`;

  const onCardClick = data => {
    const locationPath = props.location;
    RouteUtil.setRouteChange(
      props,
      `/careers/${data.urlSlug}`,
      locationPath.hash,
      locationPath.pathname
    );
  };

  const image_margin = length === 1 ? '3%' : '8%';
  const text_margin = length === 1 ? '4vh' : {};

  return (
    <div
      className={'join-our-team-mobile-card'}
      onClick={() => onCardClick(props.data)}
    >
      <div className={'carousel-image'} style={{ marginLeft: image_margin }}>
        <Image
          src={listMobileImageUrl}
          alt={'team-image'}
          thumbNail={thumbNailUrlMobile}
        />
      </div>
      <h1 className={'title'} style={{ marginLeft: text_margin }}>
        {name}
      </h1>
      <div className={'secondary-info'}>
        <span className={'location'}>{location}</span>
        <br />
        <span className={'post-timing'}>{distance}</span>
      </div>
    </div>
  );
};

export default withRouter(JoinOurTeamMobileCard);
